var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { PROVIDERS_API, getData } from 'src/Utils';
import { useQuery } from 'react-query';
import { useMemo } from 'react';
export var useProviderOptions = function () {
    var _a = useQuery([PROVIDERS_API], function () { return getData('/providers'); }, {
        refetchOnWindowFocus: false,
    }), data = _a.data, isLoading = _a.isLoading;
    var _b = useMemo(function () {
        if (!(data === null || data === void 0 ? void 0 : data.providers)) {
            return { providers: [], providerOptions: [] };
        }
        var sortedProviders = __spreadArrays(data.providers).sort(function (a, b) {
            return a.name.localeCompare(b.name, 'es');
        });
        var options = sortedProviders.map(function (provider) { return ({
            label: provider.name,
            value: provider.id,
        }); });
        return { providers: sortedProviders, providerOptions: options };
    }, [data]), providers = _b.providers, providerOptions = _b.providerOptions;
    return { isLoading: isLoading, providers: providers, providerOptions: providerOptions };
};
